var _circle, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9545,
    cy: 10.9545,
    r: 6.95455,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.9545,
    cy: 10.9545,
    r: 6.95455,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13.7576,
    width: 13.9091,
    height: 5.15151,
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8.60608,
    width: 13.9091,
    height: 5.15151,
    fill: "#6FB1D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.45456,
    width: 13.9091,
    height: 5.15151,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37148 6.42215C6.99796 6.45088 7.10331 6.91058 7.05543 7.16917C6.92135 8.96011 6.73938 10.8085 7.28528 12.5611C7.71626 13.969 8.7506 15.1278 10.0052 15.8844C10.3117 16.0568 10.6086 16.2675 10.9534 16.3633C11.3173 16.258 11.6238 16.0377 11.9494 15.8557C13.1849 15.1087 14.1905 13.9498 14.6214 12.5611C15.1769 10.7894 14.9854 8.90265 14.8417 7.08297C14.813 6.83397 14.8513 6.39341 14.4778 6.42215H7.37148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5258 6.69989H10.9439H7.3716C7.08428 10.502 6.615 13.9786 10.9439 16.076C15.2824 13.9786 14.8035 10.502 14.5258 6.69989Z",
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2134 10.0232C12.7633 10.1094 12.3036 10.186 11.8439 10.186H11.3459V9.27615H11.4608C11.9109 9.27615 12.3802 9.36235 12.8303 9.44854C12.6963 9.01757 12.6963 8.7494 12.8303 8.30885C12.3706 8.40462 11.9109 8.48124 11.4512 8.48124H11.3459V8.42378C11.3459 7.97365 11.4321 7.50436 11.5183 7.06381C11.0777 7.19789 10.8095 7.19789 10.3786 7.06381C10.4648 7.50436 10.551 7.97365 10.551 8.42378V8.48124H10.436C9.98591 8.48124 9.51662 8.39505 9.06649 8.30885C9.20058 8.73983 9.20058 9.00799 9.06649 9.44854C9.51662 9.36235 9.97633 9.27615 10.436 9.27615H10.551V10.1956H10.0434C9.58366 10.1956 9.12396 10.1094 8.67383 10.0232C8.79833 10.4542 8.79833 10.7223 8.67383 11.1629C9.11438 11.0767 9.58366 10.9905 10.0434 10.9905H10.551V14.2372H11.3459V10.9809H11.8535C12.3132 10.9809 12.7729 11.0671 13.223 11.1533C13.0794 10.7223 13.0794 10.4542 13.2134 10.0232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.683 13.7487C13.683 13.2411 13.2616 12.8293 12.754 12.8293C12.4762 12.8197 12.2368 12.9442 12.0644 13.1262C11.9207 12.6378 11.4802 12.2643 10.9439 12.2643C10.4075 12.2738 9.97657 12.6378 9.82333 13.1262C9.66052 12.9442 9.42109 12.8197 9.14335 12.8197C8.63575 12.8197 8.21436 13.2316 8.21436 13.7391C8.21436 13.7775 8.21436 13.8158 8.22393 13.8541C8.27182 13.9211 8.33886 13.9882 8.38675 14.0552H8.36759C8.94222 14.8118 9.75629 15.5014 10.9439 16.076C12.1314 15.5014 12.9455 14.8214 13.5201 14.0648H13.501C13.5489 13.9977 13.6159 13.9307 13.6638 13.8541C13.6734 13.8253 13.683 13.787 13.683 13.7487Z",
    fill: "#6FB1D6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.e325db68083e699b810781260620dc21.svg";
export { ForwardRef as ReactComponent };